<template>
  <div class="option">
    <div
      v-if="isToggleStyle"
      :class="{
        activate: isActivate,
        success: isDone && answer === option,
        error: isActivate && isDone && option !== answer
      }"
      class="letter"
      >
      <span v-if="isDone && answer === option">对</span>
      <span v-else-if="isActivate && isDone && answer !== option">错</span>
      <span v-else>-</span>
    </div>
    <div
      v-else
      :class="{
        activate: isActivate,
        success: isDone && answer === option,
        error: isActivate && isDone && option !== answer
      }"
      class="letter">
      {{numberToLetter(index)}}
    </div>
    <div v-if="isImage" class="text">
      <img :src="option" alt="">
    </div>
    <div v-else class="text" v-html="option"></div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    option: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
    isToggleStyle: {
      type: Boolean,
      required: true,
    },
    isDone: {
      type: Boolean,
      required: false,
    },
    isActivate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isImage() {
      return /^https:\/\//.test(this.option);
    },
  },
  methods: {
    numberToLetter(index) {
      return ['A', 'B', 'C', 'D'][index];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .option {
    width: 50%;
    display: flex;
    margin-bottom: 15px;
    cursor: pointer;
    .letter {
      width: 35px;
      height: 35px;
      border: 1px solid $primary;
      border-radius: 50%;
      text-align: center;
      line-height: 35px;
      color: $primary;
    }
    .activate {
      background-color: $primary;
      color: #fff;
    }
    .success {
      background-color: $success;
      border-color: $success;
      color: #fff;
    }
    .error {
      background-color: $danger;
      border-color: $danger;
      color: #fff;
    }
    .text {
      width: 80%;
      margin-left: 15px;
      line-height: 35px;
      user-select: none;
      img {
        max-width: 330px;
        max-height: 100px;
        // width: 110px;
      }
    }
  }
</style>
